<template>
    <div class="pos-absolute pos-top pos-left w-full h-full d-flex flex-justify-center">
        <img
            class="h-full mx-auto d-block"
            style="object-fit: cover"
            :src="`${$scope.CDN_IMAGES}/images/site/2021/brand-book/${src}?w=1920&auto=compress,format&q=65`"
        />
    </div>
</template>

<script>
    export default {
        name: 'BrandBookSectionHeroImage',

        props: {
            src: { type: String, required: true },
        },
    };
</script>
